
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/46842361a9a2459ecf5ba33a5b883dd8/528c189c02933955dfb66401a4d5da9a.webp"
          alt="Sailing Hero"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-5xl mt-16 md:mt-0">
        <h1 className="text-4xl md:text-7xl font-bold text-white mb-6 tracking-tight">
          Sail Beyond The Norm
        </h1>
        <p className="text-lg md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto font-light">
          Experience the freedom of the open sea with our premium cruising, racing, and training programs
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('cruising')}
            className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-md text-base font-medium transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Explore Cruising
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-md text-base font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            Get in Touch
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
